import fillProductKey from './middlewares/fillProductKey'
import populate from './middlewares/populate'
import productsC from './ui/productsC'

module.exports = {
  model: 'products',
  name: 'C-隱形資料',
  ui: productsC,
  middlewares: [populate, fillProductKey],
}



// WEBPACK FOOTER //
// ./src/views/productsC.js